import Table from 'components/reports/depreciation/ReportsDepreciationTable';
import Header from 'components/reports/depreciation/ReportsDepreciationHeader';
import Filters from 'components/reports/depreciation/ReportsDepreciationFilters';

export default { Table, Header, Filters };



// WEBPACK FOOTER //
// src/components/reports/depreciation/index.js